export default function (params) {
  var self = this;

  self.courseworkFieldEntries = ko.observableArray();

  self.bindData = function(data){
    var mapping = {
      create: function(options) {
        return new Kadenze.GenericFileViewModel(options.data);
      }
    };

    var mapped_entries = ko.mapping.fromJS(JSON.parse(data), mapping);

    self.courseworkFieldEntries(mapped_entries());
  };

  self.bindData(params);

  return self;
}

